import { useState } from "react";
import { toast } from "sonner";
import { updateMe, CLUB_BASE } from "./clubApi";
import { Btn, Card, Field, inputCls } from "./ui";
import MyTemplates from "./MyTemplates";

export default function TeamSettings({ user, onUser }) {
  const [f, setF] = useState({ name: user.name || "", whatsapp: user.whatsapp || "", slug: user.slug || "", benvenuto: user.benvenuto || "" });
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { const u = await updateMe(f); onUser(u); toast.success("Profilo salvato"); } catch (e) { toast.error(e?.response?.data?.detail || "Errore nel salvataggio"); }
    setBusy(false);
  };
  return (
    <>
    <Card className="mt-6 space-y-5" data-testid="team-settings">
      <Field label="Nome che vede il cliente"><input className={inputCls} value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="settings-name" /></Field>
      <Field label="Il tuo WhatsApp" hint="Con prefisso, es. 393331234567. Il cliente ti scrive da qui."><input className={inputCls} value={f.whatsapp} onChange={(e) => setF({ ...f, whatsapp: e.target.value })} inputMode="tel" data-testid="settings-whatsapp" /></Field>
      <Field label="Il tuo link test" hint={`${window.location.origin}${CLUB_BASE}/i/${f.slug || "…"}`}><input className={inputCls} value={f.slug} onChange={(e) => setF({ ...f, slug: e.target.value })} data-testid="settings-slug" /></Field>
      <Field label="Il tuo messaggio di benvenuto" hint="Compare in cima alla pagina di ogni tuo cliente, con la tua foto. Scrivilo come parli tu: è la prima cosa calda che leggono. Puoi usare {nome} per il nome del cliente. Se lo lasci vuoto, usiamo un testo standard.">
        <textarea className={`${inputCls} min-h-[120px] text-sm leading-relaxed`} value={f.benvenuto} onChange={(e) => setF({ ...f, benvenuto: e.target.value.slice(0, 600) })} placeholder="Ciao {nome}, sono Fabiola e da oggi ti seguo io. Nessuna fretta: facciamo un passo alla volta, insieme. Se hai un dubbio scrivimi, anche per una sciocchezza." data-testid="settings-benvenuto" />
      </Field>
      <Btn onClick={save} disabled={busy} data-testid="settings-save">{busy ? "Salvo…" : "Salva"}</Btn>
    </Card>
    <MyTemplates />
    </>
  );
}
